var styles = {"iconContainer":"styles_icon-container__kauhF","accent":"styles_accent__SQAMH","coloredBackground":"styles_colored-background__hPDfZ","complement1":"styles_complement-1__GfKD7","complement2":"styles_complement-2__WJBHg","complement3":"styles_complement-3__wLhoC","valueAndLabelContainer":"styles_value-and-label-container__MJkAy","value":"styles_value__o6L5L","label":"styles_label__tLxxs"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
